import axios from 'axios';
import store from '@/store/Store';

// @ts-ignore
const API_URL = import.meta.env.VITE_API_URL;

export const fetchAlkavatVaraukset = async (date) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + '/varaus/alkavat', {
    params: { date },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchLoppuvatVaraukset = async (date) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + '/varaus/loppuvat', {
    params: { date },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchJatkuvatVaraukset = async (date) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + '/varaus/jatkuvat', {
    params: { date },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchVarausList = async (idt) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(`${API_URL}/varaus/vastaanottoList?ids=${idt.join(',')}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchAvailableReservations = async (tuoteId, date, personCount) => {
  const token = store.getState().auth.token;
  const yritysId = store.getState().auth.yritysId;
  if (!yritysId) throw new Error('YritysId puuttuu!');

  const url = new URL(`${API_URL}/saatavuus/pricelist`);
  url.searchParams.append('yritysId', `${yritysId}`);
  url.searchParams.append('tuoteId', `${tuoteId}`);
  url.searchParams.append('time', `${date}-${date}`);
  url.searchParams.append('persons', personCount);

  const res = await axios.get(url.toString(), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data;
};

export const fetchProductConstraints = async (tuoteId, date) => {
  const data = await fetchAvailableReservations(tuoteId, date, 1);
  return data;
};

export const createReservation = async (reservationData) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.post(API_URL + '/varaus/createVaraus', reservationData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
